<h2 mat-dialog-title>{{ data.id ? 'Item ID: ' + data.id : 'New Item'}}</h2>

<mat-dialog-content [formGroup]="merchForm" style="display: flex; flex-direction: column; gap: 8px;">

	<div style="display: flex; gap: 8px;">
		<div  style="flex-grow: 1; display: flex; gap: 8px; flex-direction: column;">
			<mat-form-field class="full-width">
				<mat-label>Name</mat-label>
				<input matInput formControlName="name" placeholder="Name">
			</mat-form-field>
	
			<mat-form-field>
				<mat-label>Slug</mat-label>
				<input matInput formControlName="shortcode" placeholder="Shortcode/Slug">
			</mat-form-field>
	
			<mat-form-field>
				<mat-label>Description</mat-label>
				<textarea matInput formControlName="description" placeholder="Description"></textarea>
			</mat-form-field>

			<mat-form-field subscriptSizing="dynamic">
				<mat-label>Categories</mat-label>
				<mat-select formControlName="type">
					<mat-option *ngFor="let topping of catList" [value]="topping">{{topping}}</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
		<div>
			<label>Images</label>
			<div *ngFor="let image of merchForm.controls['images']['value']">
				<img [src]="'https://support.4zzz.org.au/' + image.src" style="height: 100px; width: auto" />
			</div>
			<!-- <button mat-button>
				Add Image
			</button> -->
			<label mat-menu-item for="coverDropRef">Add Image</label>
			<input style="display: none" type="file" #coverDropRef [accept]="'image/*'" id="coverDropRef" (change)="fileBrowseHandler($event.target)" />
		</div>
	</div>
	


	<div style="display: flex; gap: 8px; justify-content: space-between; align-items: center	;">
		<div formArrayName="price" style="display: flex; gap: 4px;">
			<mat-form-field class="narrow" *ngFor="let item of merchForm.controls['price']['controls']; let i = index">
				<mat-label>{{i === 0 ? 'Sub' : 'Non-Sub'}} Price</mat-label>
				<input type="number" matInput formControlName="{{i}}" [placeholder]="i === 0 ? 'Sub' : 'Non-Sub'">
			</mat-form-field>
		</div>

		<mat-checkbox formControlName="tax">Tax</mat-checkbox>

		<mat-checkbox formControlName="public">Public</mat-checkbox>

		<mat-form-field class="narrow">
			<mat-label>Base Weight</mat-label>
			<input type="number" step=".01" matInput formControlName="weight" placeholder="Base weight (kg)">
		</mat-form-field>
	</div> 

	<div style="display: flex;">
		<h3 style="flex: 1;">Options & Inventory</h3>
		<button (click)="addOption()" mat-mini-fab color="primary" aria-label="Add option">
			<mat-icon>add</mat-icon>
		</button>
	</div>

	<div formArrayName="params" >
		<div *ngFor="let params of merchForm.controls['params']['controls']; index as paramGroup" [formGroupName]="paramGroup" style="display: flex; gap: 4px; align-items: center;">
			<mat-form-field>
				<mat-label>Type</mat-label>
				<mat-select formControlName="type">
					<mat-option (click)="alterOptions(paramGroup, opt)"  *ngFor="let opt of options" [value]="opt.type">{{opt.option}}</mat-option>
				</mat-select>
			</mat-form-field>
			<mat-form-field>
				<mat-label>Option</mat-label>
				<input matInput formControlName="value" placeholder="Option">
			</mat-form-field>
			<mat-form-field class="narrow">
				<mat-label>Inventory</mat-label>
				<input type="number" step="1" matInput formControlName="inventory" placeholder="Inventory">
			</mat-form-field>
			<mat-form-field class="narrow">
				<mat-label>Added Weight</mat-label>
				<input type="number" step=".01" matInput formControlName="weight" placeholder="Added Weight">
			</mat-form-field>
			<mat-icon (click)="removeOption(paramGroup)" mat-icon-button>
				delete
			</mat-icon>
		</div>
	</div>



</mat-dialog-content>

<mat-dialog-actions>
	<button mat-raised-button (click)="saveItem()" [disabled]="merchForm.pristine">
		Save
	</button>
</mat-dialog-actions>